export default __webpack_public_path__ + "assets/github.77cca29.png";